function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.55 2.22L16.16.54A1.51 1.51 0 0015 0H3c-.47 0-.88.21-1.15.55L.46 2.22C.17 2.57 0 3.01 0 3.5V16a2 2 0 002 2h14c1.1 0 2-.9 2-2V3.5c0-.49-.17-.93-.45-1.28zM9 6.5l5.5 5.5H11v2H7v-2H3.5L9 6.5zM2.12 2l.82-1h12l.93 1H2.12z",
  fill: "#879297",
  fillRule: "nonzero"
});

function SvgUpload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18"
  }, props), _ref);
}

export default SvgUpload;